import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import './styles/v3sys-theme.css';
import App from './App';
import { getCsrfToken } from './services/api';
import toast from 'react-hot-toast';

// Globalny wrapper na fetch - automatycznie dodaje CSRF token, credentials,
// location_id i obsługę błędów (spójne z axios interceptorem w api.js)
const originalFetch = window.fetch;
window.fetch = function(url, options = {}) {
  const method = (options.method || 'GET').toUpperCase();

  // X-Requested-With header (CSRF ochrona -- custom header)
  options.headers = options.headers || {};
  if (options.headers instanceof Headers) {
    if (!options.headers.has('X-Requested-With')) {
      options.headers.set('X-Requested-With', 'XMLHttpRequest');
    }
  } else {
    if (!options.headers['X-Requested-With']) {
      options.headers['X-Requested-With'] = 'XMLHttpRequest';
    }
  }

  // CSRF token dla mutujących requestów
  if (['POST', 'PUT', 'DELETE', 'PATCH'].includes(method)) {
    const csrfToken = getCsrfToken();
    if (csrfToken) {
      if (options.headers instanceof Headers) {
        if (!options.headers.has('X-CSRF-Token')) {
          options.headers.set('X-CSRF-Token', csrfToken);
        }
      } else {
        if (!options.headers['X-CSRF-Token']) {
          options.headers['X-CSRF-Token'] = csrfToken;
        }
      }
    }
  }

  // Dołącz location_id z localStorage (jak axios interceptor)
  try {
    const saved = localStorage.getItem('selectedLocation');
    if (saved && typeof url === 'string' && url.includes('/api/')) {
      const location = JSON.parse(saved);
      if (location?.id) {
        const urlObj = new URL(url, window.location.origin);
        if (!urlObj.searchParams.has('location_id')) {
          urlObj.searchParams.set('location_id', location.id);
          url = urlObj.toString();
        }
      }
    }
  } catch (e) {
    // Ignoruj błędy parsowania
  }

  // Zawsze wysyłaj cookies (session)
  if (!options.credentials) {
    options.credentials = 'include';
  }

  // Obsługa błędów — toast dla 5xx z request_id (jak axios interceptor)
  return originalFetch.call(this, url, options).then(response => {
    if (response.status >= 500) {
      const requestId = response.headers.get('x-request-id');
      const reqIdMsg = requestId ? ` (ID: ${requestId})` : '';
      response.clone().json().catch(() => ({})).then(data => {
        const message = data?.message || data?.error || 'Wystąpił błąd serwera';
        toast.error(`Błąd serwera: ${message}${reqIdMsg}`);
      });
    }
    return response;
  }).catch(error => {
    // Błąd sieciowy (brak połączenia)
    if (error.name === 'TypeError' && error.message.includes('fetch')) {
      toast.error('Brak połączenia z serwerem');
    }
    throw error;
  });
};

// BEZPIECZENSTWO: Wyciszenie console.log/debug/info w produkcji
// Zapobiega wyciekowi danych przez konsole przegladarki
if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  console.log = noop;
  console.debug = noop;
  console.info = noop;
  // console.warn i console.error zostawione dla diagnostyki
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
// Zmiana do wymuszenia nowego hashu...
